/**
 * The Assign sub-view's own address (Manage tab, sub-view path "assign"; plan
 * docs/plans/lms-plan.md 18.3; WP-43).
 */
export const ASSIGN_BASE = '/lms/manage/assign';
